var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading-spinner" }, [
    _c("span", {
      staticClass: "loading-spinner__spinner",
      class: _vm.color ? "loading-spinner__spinner--" + _vm.color : ""
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }